class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      sidebarDrawer: this.querySelector('.menu-drawer'),
      sidebarDrawerButton: this.querySelectorAll('.button-close'),
      focusableElements: Array.from(this.querySelectorAll('summary, a[href], button:enabled, [tabindex="0"], [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe')),
      shopifySection: document.querySelector('#shopify-section-menu-drawer') || document.querySelector('#shopify-section-mega-menu-drawer')
    };

    document.querySelectorAll('.burger-menu').forEach(item => item.addEventListener('click', () => {
      if (this.elements.sidebarDrawer.classList.contains('open')) {
        this.closeDrawer();
      } else {
        this.openDrawer();
      }
    }));
    document.querySelectorAll('.burger-menu').forEach(item => {
      item.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ENTER') {
          this.openDrawer()
          trapFocus(
            event.target.closest('.burger-menu'),
            this.elements.focusableElements[0]
          );
        }
      })
    });

    if (Shopify.designMode) {
      this.elements.shopifySection.addEventListener('shopify:section:select', this.openDrawer.bind(this));
      this.elements.shopifySection.addEventListener('shopify:section:deselect', this.closeDrawer.bind(this));
      this.elements.shopifySection.addEventListener('shopify:section:unload', this.openDrawer.bind(this))
    }

    this.elements.sidebarDrawerButton.forEach(item => item.addEventListener('click', this.closeDrawer.bind(this)));
    document.addEventListener('keyup', (event) => {
      if (event.code?.toUpperCase() === 'ESCAPE' && this.elements.sidebarDrawer.classList.contains('open')) this.closeDrawer()
    })

    this.setDrawerOffset();
    window.addEventListener('resize', this.setDrawerOffset.bind(this));
    window.addEventListener('scroll', this.setDrawerOffset.bind(this));

  }

  setDrawerOffset() {
    const announcementBar = document.querySelector('.announcement-bar');
    const mobileHeader = document.querySelector('.mobile-header-section');

    let totalHeight = 0;

    if (mobileHeader) totalHeight += mobileHeader.offsetHeight;

    if (announcementBar && window.scrollY === 0) {
      totalHeight += announcementBar.offsetHeight;
    }

    document.documentElement.style.setProperty('--drawer-top-offset', `${totalHeight}px`);
  }

  openDrawer() {
    this.setDrawerOffset();
    this.elements.sidebarDrawer.removeAttribute('hidden')
    this.elements.sidebarDrawer.classList.add('open')
    document.body.classList.add('hidden')
    document.querySelector('.mobile-header-section')?.classList.replace('transparent', 'colored');
    document.querySelectorAll('.burger-icon').forEach(h => h.classList.add('active'));

    if(document.querySelector('[id$="menu-drawer"] .pinned-block') && document.querySelector('[id$="menu-drawer"] .nested-submenu')) {
      let bottomPadding = document.querySelector('[id$="menu-drawer"] .pinned-block').offsetHeight + 16
      this.elements.sidebarDrawer.setAttribute('style', `--height-pinned-block: ${bottomPadding}px`)
    }
  }

  offsetHeight() {
    if(document.querySelector('[id$="menu-drawer"] .pinned-block') && document.querySelector('[id$="menu-drawer"] .nested-submenu')) {
      let bottomPadding = document.querySelector('[id$="menu-drawer"] .pinned-block').offsetHeight + 16
      this.elements.sidebarDrawer.setAttribute('style', `--height-pinned-block: ${bottomPadding}px`)
    }
  }

  closeDrawer() {
    this.elements.sidebarDrawer.scrollTop = 0
    this.elements.sidebarDrawer.setAttribute('hidden', 'true')
    this.elements.sidebarDrawer.classList.remove('open')
    document.body.classList.remove('hidden')
    document.querySelectorAll('.burger-icon').forEach(h => h.classList.remove('active'));

    if(window.scrollY === 0){
      const overlappingSection = document.querySelector('main .shopify-section:first-child:has(.overlapping-section)');
      if (overlappingSection) {
        document.querySelector('.mobile-header-section')?.classList.replace('colored', 'transparent');
      }
    }

    document.dispatchEvent(new CustomEvent('body:visible'));
    document.querySelectorAll('.burger-menu').forEach(item => item.blur());
  }

}
customElements.define('menu-drawer', MenuDrawer);